var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"value":_vm.country,"items":_vm.countryList,"rules":_vm.getRules(),"label":_vm.required ? _vm.$t('SCountry.countryMandatory') : _vm.$t('SCountry.country'),"item-value":'code',"item-text":'native',"validate-on-blur":"","persistent-hint":"","outlined":_vm.outlined},on:{"input":function (country) {
      this$1.$emit('update:country', country)
    },"blur":function($event){return _vm.$emit('update:country', _vm.country)}}})}
var staticRenderFns = []

export { render, staticRenderFns }